// seo.ts
//
// Thin, typed wrapper around ./seoShared.js for use from React components
// (react-helmet-async). seoShared.js is the actual source of truth — see
// the comment at the top of that file. scripts/build-seo.js requires the
// very same file, so the two runtimes can never drift apart.

import type { Article, ArticleLang } from '../types/article';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const shared = require('./seoShared.js');

export const SITE_URL: string = shared.SITE_URL;
export const LANGS: ArticleLang[] = shared.LANGS;
export const BUSINESS = shared.BUSINESS;

export interface PageMeta {
  title: string;
  description: string;
}

export function absoluteUrl(pathname: string): string {
  return shared.absoluteUrl(pathname);
}

export function homePath(lang: ArticleLang): string {
  return shared.homePath(lang);
}

export function articlesListPath(lang: ArticleLang): string {
  return shared.articlesListPath(lang);
}

export function articlePath(lang: ArticleLang, slug: string): string {
  return shared.articlePath(lang, slug);
}

export function privacyPath(lang: ArticleLang): string {
  return shared.privacyPath(lang);
}

export function getHomeMeta(lang: ArticleLang, t: any): PageMeta {
  return shared.getHomeMeta(lang, t);
}

export function getArticlesListMeta(lang: ArticleLang, t: any): PageMeta {
  return shared.getArticlesListMeta(lang, t);
}

export function getArticleMeta(
  lang: ArticleLang,
  article: Article,
  t: any
): PageMeta & { practiceLabel: string } {
  return shared.getArticleMeta(lang, article, t);
}

export function getPrivacyMeta(lang: ArticleLang, t: any): PageMeta {
  return shared.getPrivacyMeta(lang, t);
}

export function toIsoDate(date: string): string {
  return shared.toIsoDate(date);
}

export function buildLegalServiceSchema(lang: ArticleLang): object {
  return shared.buildLegalServiceSchema(lang);
}

export function buildFaqPageSchema(lang: ArticleLang, t: any): object {
  return shared.buildFaqPageSchema(lang, t);
}

export function buildArticleSchema(
  lang: ArticleLang,
  article: Article,
  practiceLabel: string
): object {
  return shared.buildArticleSchema(lang, article, practiceLabel);
}

export function buildBreadcrumbSchema(
  crumbs: { name: string; path: string }[]
): object {
  return shared.buildBreadcrumbSchema(crumbs);
}
